var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.988281,
    height: 19.988281,
    viewBox: "0 0 19.9883 19.9883",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip494_425"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "interface-user-profile-focus--close-geometric-human-person-profile-focus-user--Streamline-Core",
    rx: 0,
    width: 19.322094,
    height: 19.322094,
    transform: "translate(0.333140 0.333140)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "interface-user-profile-focus--close-geometric-human-person-profile-focus-user--Streamline-Core",
    rx: 0,
    width: 19.322094,
    height: 19.322094,
    transform: "translate(0.333140 0.333140)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip494_425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99 11.42C8.02 11.42 6.42 9.82 6.42 7.85C6.42 5.88 8.02 4.28 9.99 4.28C11.96 4.28 13.56 5.88 13.56 7.85C13.56 9.82 11.96 11.42 9.99 11.42Z",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332558,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.71 15.34C13.41 14.19 11.73 13.55 9.99 13.55C8.25 13.55 6.57 14.19 5.26 15.34",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332558,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.27 14.99L19.27 17.84C19.27 18.22 19.12 18.58 18.85 18.85C18.58 19.12 18.22 19.27 17.84 19.27L14.99 19.27",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332558,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.99 0.71L17.84 0.71C18.22 0.71 18.58 0.86 18.85 1.13C19.12 1.39 19.27 1.76 19.27 2.14L19.27 4.99",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332558,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.71 4.99L0.71 2.14C0.71 1.76 0.86 1.39 1.13 1.13C1.39 0.86 1.76 0.71 2.14 0.71L4.99 0.71",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332558,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.99 19.27L2.14 19.27C1.76 19.27 1.39 19.12 1.13 18.85C0.86 18.58 0.71 18.22 0.71 17.84L0.71 14.99",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332558,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.48beccbeaf8d6d40bc778dcdee00e32d.svg";
export { ForwardRef as ReactComponent };